<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>退货</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="simple-row">
            <div class="left">
                <button class="swb-btn swb-btn-small" @click="showItemListDlg">选择商品</button>
            </div>
        </div>
        <div class="table-layout">
            <el-table ref="multipleTable" :data="goodsRecvVoucher.goodsRecvVoucherItemList" border tooltip-effect="dark" style="width: 100%">
                <el-table-column align="center" label="资产信息" v-if="showAssetInfo">
                    <el-table-column align="left" width="130" prop="devcName" label="名称" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" width="100" prop="devcCatName" label="分类" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" width="100" prop="devcBrandName" label="品牌" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" width="130" prop="devcModel" label="型号" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" width="130" prop="devcFixedSpec" label="规格" show-overflow-tooltip></el-table-column>
                </el-table-column>
                <el-table-column align="center" label="商品信息" v-if="showAssetInfo">
                    <el-table-column align="left" width="130" prop="title" label="名称" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" width="100" prop="catName" label="分类" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" width="100" prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" width="130" prop="model" label="型号" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" width="130" prop="fixedSpec" label="规格" show-overflow-tooltip></el-table-column>
                </el-table-column>
                <el-table-column align="left" prop="title" label="名称" width="150" show-overflow-tooltip v-if="!showAssetInfo"></el-table-column>
                <el-table-column align="left" width="120" prop="catName" label="分类" show-overflow-tooltip v-if="!showAssetInfo"></el-table-column>
                <el-table-column align="left" width="100" prop="brandName" label="品牌" show-overflow-tooltip v-if="!showAssetInfo"></el-table-column>
                <el-table-column align="left" width="130" prop="model" label="型号" show-overflow-tooltip v-if="!showAssetInfo"></el-table-column>
                <el-table-column align="left" width="130" prop="fixedSpec" label="规格" show-overflow-tooltip v-if="!showAssetInfo"></el-table-column>

                <el-table-column align="right" prop="shipQuantity" label="已收货数量" show-overflow-tooltip></el-table-column>
                <el-table-column align="right" prop="exchgSumQuantity" label="已换货数量" show-overflow-tooltip></el-table-column>
                <el-table-column align="right" prop="assetCheckedQuantity" label="已验收数量" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column align="right" prop="returnSumQuantity" label="已退货数量" show-overflow-tooltip></el-table-column>
                <el-table-column align="right" prop="returnQuantity" label="退货数量" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <!--  + scope.row.assetCheckedQuantity -->
                        <el-input type="text" class="text-right" :disabled="true" v-model="scope.row.returnQuantity" @change="returnQuantityChange(scope.row)" v-if="scope.row.assetType == 0"></el-input>
                        <!--+ scope.row.assetInQuantity -->
                        <el-input type="text" class="text-right" :disabled="scope.row.shipQuantity == (scope.row.returnSumQuantity + scope.row.exchgSumQuantity + scope.row.assetCheckedQuantity)" v-model="scope.row.returnQuantity"
                                  @change="returnQuantityChange(scope.row)" v-if="scope.row.assetType == 1"></el-input>
                        <el-input type="text" class="text-right" :disabled="scope.row.shipQuantity == (scope.row.returnSumQuantity + scope.row.exchgSumQuantity)" v-model="scope.row.returnQuantity" @change="returnQuantityChange(scope.row)"
                                  v-if="scope.row.assetType == 3"></el-input>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="描述" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-input type="text" v-model="scope.row.desc"></el-input>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="140" fixed="right">
                    <template slot-scope="scope">
                        <a class="swb-btn-link" @click="returnGoods(scope.row)" v-if="scope.row.assetType == 0">退货明细</a>
                        <a class="swb-btn-link" @click="removeGoods(scope.$index)">移除</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-form :model="goodsRecvVoucher">
            <div class="simple-form">
                <div class="form-group center">
                    <div class="form-label">
                        <label>退货原因</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="exceptional">
                            <el-select placeholder="请选择" v-model="goodsRecvVoucher.returnCause" :clearable=true>
                                <el-option v-for="item in goodsReturnCauseList" :key="item.name" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>

                <div class="form-group center">
                    <div class="form-label">
                        <label>退货原因说明</label>
                    </div>
                    <div class="form-value width-1-5x">
                        <el-form-item prop="dateStart">
                            <el-input type="textarea" v-model="goodsRecvVoucher.returnDesc"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </el-form>
        <div class="form-toolbar">
            <button class="swb-btn swb-btn-small swb-btn-primary mr10" @click="prevContract">返回</button>
            <button class="swb-btn swb-btn-small" @click="saveGoodsRecvVoucher()">提交</button>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes} from '../../app.vues'
    import {showGoodsRecvReturnItemListDialog} from '../order/dialog'
    import {getMerchantBizParam} from '../asset/assetMain'

    import goodsDelivApi from '../../api/goodsDeliv'
    import goodsOperApi from '../../api/goodsOper'

    import SwbGoodsRecvVoucherItemSelect from './GoodsRecvVoucherItemSelect';
    Vue.regist(SwbGoodsRecvVoucherItemSelect);
    //
    import SwbGoodsReturnVoucherList from './GoodsReturnVoucherList';
    Routes.add(SwbGoodsReturnVoucherList);

    export default {
        name: 'swb-goods-return-voucher-save',
        path: '/goods/return/voucher/save',
        avlActions: '',
        avlScopes: 'retailer',
        notAsResc: true,
        authen: false,
        desc: '保存退货单信息',
        data: function () {
            return {
                goodsRecvVoucher: {},
                goodsReturnCauseList: [],
                showAssetInfo: false
            }
        },
        created: function () {
            //
            let id = this.$route.query.id || null;
            //
            let self = this;
            //
            getMerchantBizParam("display.asset.related.info.in.trading", function (result) {
                self.showAssetInfo = Utils.isTrue(result);
            });
            this.getGoodsRecvVoucher(id);
            this.getGoodsExchgCauseList();
        },
        methods: {
            prevContract: function () {
                this.$router.back(-1);
            },
            // 退货详情
            getGoodsRecvVoucher: function (id) {
                let self = this;
                let postData = {};
                postData.id = id;
                //
                let msgBoxDlg = MsgBox.loading();
                goodsDelivApi.getGoodsRecvVoucherInfo(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type == "info") {
                        self.goodsRecvVoucher = result.data;
                        self.goodsRecvVoucher.returnCause = -1;
                        if (self.goodsRecvVoucher != null) {
                            self.goodsRecvVoucher.goodsRecvVoucherItemList = [];
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 退货原因
            getGoodsExchgCauseList: function () {
                let self = this;
                let postData = {};
                goodsOperApi.getGoodsReturnCauseList(postData, function (result) {
                    if (result.type == "info") {
                        self.goodsReturnCauseList = result.data;
                        let endData = {id: -1, name: '其他'};
                        self.goodsReturnCauseList.push(endData);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            showItemListDlg: function () {
                let self = this;
                let id = this.$route.query.id || null;
                Vue.$showDialog({
                    title: "选择商品",
                    showCloseBtn: true,
                    width: -200,
                    height: 700,
                    template: '<swb-goods-recv-voucher-item-select :voucherId="voucherId" :selectItems="selectItems" :useFor="useFor" :ioFlag="ioFlag" ref="swb_recv_voucher_item_select"></swb-goods-recv-voucher-item-select>',
                    data: {
                        selectItems: self.goodsRecvVoucher.goodsRecvVoucherItemList,
                        voucherId: id,
                        ioFlag: 1,
                        useFor: 'return'
                    },
                    okClicked: function () {
                        let selfDlg = this;
                        let result = selfDlg.$refs.swb_recv_voucher_item_select.getDlgResult() || {};
                        if (result.type === 'info') {
                            let resultData = result.data;
                            if (resultData != null && resultData.length > 0) {
                                for (let i = 0; i < resultData.length; i++) {
                                    let data = resultData[i];
                                    data.shipQuantity = data.quantity;
                                    if (data.assetType != 0) {
                                        data.returnQuantity = data.shipQuantity - (data.returnSumQuantity + data.exchgSumQuantity + data.assetCheckedQuantity);
                                        if (Utils.isNoB(data.returnQuantity) || data.returnQuantity < 0) {
                                            data.returnQuantity = 0;
                                        }
                                    }
                                    data.desc = null;
                                }
                                self.goodsRecvVoucher.goodsRecvVoucherItemList = Utils.merge([], resultData);
                                return true;
                            }
                        } else {
                            MsgBox.warning(result.message);
                        }
                        return false;
                    },
                    methods: {},
                    lifecycle: {
                    }
                });
            },
            // 退货明细
            returnGoods: function (row) {
                let self = this;
                let params = {
                    title: '退货明细',
                    recvVoucherItemId: row.id,
                    recvVoucherId: row.voucherId,
                    returnQuantity: row.returnQuantity,
                    goodsRecvReturnItemList: row.goodsRecvReturnItemList,
                    optionFlag: "return"//
                };
                showGoodsRecvReturnItemListDialog(params, function (goodsRecvReturnItemList) {
                    goodsRecvReturnItemList = goodsRecvReturnItemList || [];
                    let goodsRecvVoucher = self.goodsRecvVoucher || {};
                    let goodsRecvVoucherItemList = goodsRecvVoucher.goodsRecvVoucherItemList || [];
                    for (let i = 0; i < goodsRecvVoucherItemList.length; i++) {
                        let goodsRecvVoucherItem = goodsRecvVoucherItemList[i];
                        if (goodsRecvVoucherItem.id == row.id) {
                            goodsRecvVoucherItem.returnQuantity = goodsRecvReturnItemList.length;
                            goodsRecvVoucherItem.goodsRecvReturnItemList = Utils.merge([], goodsRecvReturnItemList);
                        }
                    }
                    goodsRecvVoucher.goodsRecvVoucherItemList = Utils.merge([], goodsRecvVoucherItemList);
                    self.goodsRecvVoucher = Utils.merge({}, goodsRecvVoucher);
                });
            },
            // 移除商品
            removeGoods: function (index) {
                let goodsRecvVoucherItemList = this.goodsRecvVoucher.goodsRecvVoucherItemList;
                for (let i = 0; i < goodsRecvVoucherItemList.length; i++) {
                    if (i == index) {
                        goodsRecvVoucherItemList.remove(goodsRecvVoucherItemList[i]);
                    }
                }
                this.goodsRecvVoucher.goodsRecvVoucherItemList = Utils.merge([], goodsRecvVoucherItemList);
            },
            // 退货数量校验
            returnQuantityChange: function (row) {
                let assetType = row.assetType;
                let returnQuantity = row.returnQuantity;
                if (!Utils.isNoB(returnQuantity)) {
                    if (!Utils.isNaturalStr(returnQuantity) || returnQuantity <= 0) {
                        row.returnQuantity = null;
                        MsgBox.warning("只能输入大于0的整数！");
                    } else {
                        let quantity = row.shipQuantity || 0;
                        let returnSumQuantity = row.returnSumQuantity || 0;
                        let exchgSumQuantity = row.exchgSumQuantity || 0;
                        let assetInQuantity = row.assetInQuantity || 0;
                        let assetCheckedQuantity = row.assetCheckedQuantity || 0;
                        let returnableQuantity = 0; // 可退货数量
                        if (!Utils.isNoB(assetType) && assetType == 0) {
                            returnableQuantity = parseInt(quantity) - parseInt(returnSumQuantity) - parseInt(exchgSumQuantity) - parseInt(assetCheckedQuantity);
                            if (returnableQuantity < 0) {
                                returnableQuantity = 0;
                            }
                        } else if (!Utils.isNoB(assetType) && assetType == 1) {
                            returnableQuantity = parseInt(quantity) - parseInt(returnSumQuantity) - parseInt(exchgSumQuantity) - parseInt(assetCheckedQuantity);
                            if (returnableQuantity < 0) {
                                returnableQuantity = 0;
                            }
                        } else if (!Utils.isNoB(assetType) && assetType == 3) {
                            returnableQuantity = parseInt(quantity) - parseInt(returnSumQuantity) - parseInt(exchgSumQuantity);
                            if (returnableQuantity < 0) {
                                returnableQuantity = 0;
                            }
                        }
                        if (parseInt(returnQuantity) > returnableQuantity) {
                            row.returnQuantity = null;
                            MsgBox.warning("退货数量超过了可退货数量【" + returnableQuantity + "】！");
                        }
                    }
                }
            },
            // 保存退货单
            saveGoodsRecvVoucher: function () {
                let self = this;
                let goodsRecvVoucherItemList = self.goodsRecvVoucher.goodsRecvVoucherItemList || [];
                let totalCount = 0;
                if (goodsRecvVoucherItemList.length > 0) {
                    for (let i = 0; i < goodsRecvVoucherItemList.length; i++) {
                        let goodsRecvVoucherItem = goodsRecvVoucherItemList[i];
                        let returnQuantity = goodsRecvVoucherItem.returnQuantity;
                        if (!Utils.isNaturalStr(returnQuantity, true)) {
                            MsgBox.warning(goodsRecvVoucherItem.title + "请输入大于0的有效退货数量！");
                            return;
                        }
                        //
                        let assetType = goodsRecvVoucherItem.assetType;
                        let quantity = goodsRecvVoucherItem.shipQuantity || 0;
                        let returnSumQuantity = goodsRecvVoucherItem.returnSumQuantity || 0;
                        let exchgSumQuantity = goodsRecvVoucherItem.exchgSumQuantity || 0;
                        let assetInQuantity = goodsRecvVoucherItem.assetInQuantity || 0;
                        let assetCheckedQuantity = goodsRecvVoucherItem.assetCheckedQuantity || 0;
                        let returnableQuantity = 0; // 可退货数量
                        if (!Utils.isNoB(assetType) && assetType == 0) {
                            returnableQuantity = parseInt(quantity) - parseInt(returnSumQuantity) - parseInt(exchgSumQuantity);// - parseInt(assetCheckedQuantity);
                            if (returnableQuantity < 0) {
                                returnableQuantity = 0;
                            }
                        } else if (!Utils.isNoB(assetType) && assetType == 1) {
                            returnableQuantity = parseInt(quantity) - parseInt(returnSumQuantity) - parseInt(exchgSumQuantity);// - parseInt(assetInQuantity);
                            if (returnableQuantity < 0) {
                                returnableQuantity = 0;
                            }
                        } else if (!Utils.isNoB(assetType) && assetType == 3) {
                            returnableQuantity = parseInt(quantity) - parseInt(returnSumQuantity) - parseInt(exchgSumQuantity);
                            if (returnableQuantity < 0) {
                                returnableQuantity = 0;
                            }
                        }
                        if (parseInt(returnQuantity) > returnableQuantity) {
                            MsgBox.warning(goodsRecvVoucherItem.title + "退货数量超过了可退货数量【" + returnableQuantity + "】！");
                            return false;
                        } else {
                            if (!Utils.isNoB(assetType) && assetType == 0) {
                                //
                                let goodsRecvReturnItemList = goodsRecvVoucherItem.goodsRecvReturnItemList || [];
                                if (goodsRecvReturnItemList.length <= 0) {
                                    MsgBox.warning(goodsRecvVoucherItem.title + "请选择退货明细！");
                                    return false;
                                } else if (goodsRecvReturnItemList.length != parseInt(returnQuantity)) {
                                    MsgBox.warning(goodsRecvVoucherItem.title + "选择的退货明细数量与退货数量不一致，退货数量为【" + parseInt(returnQuantity) + "】退货明细数量为【" + goodsRecvReturnItemList.length + "】！");
                                    return false;
                                }
                            }
                            //
                            goodsRecvVoucherItem.quantity = parseInt(returnQuantity);
                            totalCount += ParseInt(goodsRecvVoucherItem.returnQuantity);
                        }
                    }
                    self.goodsRecvVoucher.goodsRecvVoucherItemList = Utils.merge([], goodsRecvVoucherItemList);
                } else {
                    MsgBox.warning("至少选择一个商品！");
                    return false;
                }

                let goodsRecvVoucher = self.goodsRecvVoucher;
                goodsRecvVoucher.deriveId = goodsRecvVoucher.id;
                goodsRecvVoucher.deliverType = -1;
                goodsRecvVoucher.id = null;
                goodsRecvVoucher.ioFlag = -1;
                goodsRecvVoucher.arriveDelayed = false;
                goodsRecvVoucher.dueArriveDate = null;
                goodsRecvVoucher.actualArriveDate = null;
                goodsRecvVoucher.arriveDelayedDays = 0;
                goodsRecvVoucher.receiveTime = null;
                goodsRecvVoucher.receiveDate = null;
                goodsRecvVoucher.exceptional = false;
                goodsRecvVoucher.exceptionDesc = null;
                goodsRecvVoucher.totalCount = totalCount;
                let theLoad = MsgBox.loading("退货申请中.....");
                goodsDelivApi.saveGoodsReturnVoucher(goodsRecvVoucher, function (result) {
                    theLoad.hide();
                    if (result.type == "info") {
                        MsgBox.success("退货申请提交成功");
                        self.$router.push({
                            path: SwbGoodsReturnVoucherList.path
                        });
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsReturnVoucherSave.vue